module.exports = __webpack_public_path__ + "static/media/logo.c5f8e16e.svg";